import { render, staticRenderFns } from "./PersistPromocaoView.vue?vue&type=template&id=5fc75c9c&"
import script from "./PersistPromocaoView.vue?vue&type=script&lang=ts&"
export * from "./PersistPromocaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports